import React from 'react';
import PlanningForm from './PlanningForm';

// View-only detail (opened from the list's "View" action on submitted records).
// Reuses the full tab shell in read-only mode — no Save/Submit buttons.
const PlanningDetail = () => <PlanningForm readOnly />;

export default PlanningDetail;
